import { TriangleAlert } from "lucide-react";

export const BannerEvent = () => {
  return (
    <div className=" w-full bg-red-600 text-white text-center py-2 px-4 z-50 flex flex-wrap justify-center gap-2 items-center shadow-lg">
      <p className="font-semibold flex items-center gap-2">
         ⚠️ 
         Gala caritatif – Places limitées !
      </p>
      <a
        href="https://www.helloasso.com/associations/association-ecole-l-olivier/evenements/gala-de-l-ecole-l-olivier"
        className=" text-white font-bold transition-transform underline hover:text-blue-700"
      >
        Réservez maintenant
      </a>
    </div>
  );
};
